<template>
    <intelligence-shell
        :title="$t('pages.intelligence.entitlement.title')"
        :subtitle="$t('pages.intelligence.entitlement.subtitle')"
        @filters-change="onFiltersChange"
    >
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.entitlement.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.entitlement.error') }}
        </div>

        <template v-else-if="entitlement">
            <intelligence-entitlement-kpi-cards :kpis="entitlement.kpis"></intelligence-entitlement-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-entitlement-chart
                    :reasons="entitlement.reasons"
                    :subscriptions="entitlement.subscriptions"
                ></intelligence-entitlement-chart>
                <intelligence-entitlement-table
                    :reasons="entitlement.reasons"
                    :subscriptions="entitlement.subscriptions"
                ></intelligence-entitlement-table>
            </div>
        </template>
    </intelligence-shell>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceShell from 'components/page-elements/intelligence/IntelligenceShell'
    import IntelligenceEntitlementKpiCards from 'components/page-elements/intelligence/IntelligenceEntitlementKpiCards'
    import IntelligenceEntitlementChart from 'components/page-elements/intelligence/IntelligenceEntitlementChart'
    import IntelligenceEntitlementTable from 'components/page-elements/intelligence/IntelligenceEntitlementTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceShell,
            IntelligenceEntitlementKpiCards,
            IntelligenceEntitlementChart,
            IntelligenceEntitlementTable,
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                entitlement: null,
                filters: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.entitlement.title')
            },
        },

        methods: {
            onFiltersChange(filters) {
                this.filters = filters
                this.loadEntitlement()
            },

            loadEntitlement() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getEntitlement(this.filters)
                    .then((response) => {
                        this.entitlement = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.entitlement = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
